import { render, staticRenderFns } from "./TermsComponent.vue?vue&type=template&id=1caa3416&scoped=true&"
var script = {}
import style0 from "./TermsComponent.vue?vue&type=style&index=0&id=1caa3416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa3416",
  null
  
)

export default component.exports